// ERP(s) que o sistema usa, resolvidos UMA vez no boot (src/index.js) e lidos
// de forma síncrona em qualquer lugar até a página ser recarregada (F5).
//
// Ordem:
//   1. Backend (GET /config/erps): ERPs cadastrados em Administração › Geral ›
//      ERP; sem cadastro, a variável ERP do backend.
//   2. Se a consulta falhar ou demorar demais: REACT_APP_ERP do front.
//   3. Nada disso: lista vazia (nenhum ERP configurado).
//
// Uso — substitua aos poucos, a cada tela mexida, a leitura direta de
// `window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP`:
//   import { getErpPrincipal, temErp, getErpsSistema } from ".../services/erpSistema";
//   getErpPrincipal() === "HUBSOFT"  // troca direta do `ERP` atual
//   temErp("IXC")                    // regra global: "o sistema tem IXC?"
//
// Não leia em nível de módulo (`const ERP = getErpPrincipal()` fora de
// componente/função): o arquivo pode ser importado antes do boot terminar.

const TEMPO_LIMITE_MS = 5000;

let tipos = null; // null = ainda não carregado
let origem = null; // "backend" | "variavel" | "nenhum"
let carregadoNoBoot = false; // carregarErpsSistema já terminou

const variavelFront = () =>
  window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP || "";

function definir(lista, de) {
  tipos = [...new Set((lista || []).filter(Boolean))];
  origem = tipos.length ? de : "nenhum";
}

/**
 * Consulta o backend e guarda o resultado. Chamado uma vez, antes de renderizar
 * a aplicação. Nunca rejeita: em falha, usa REACT_APP_ERP.
 */
export async function carregarErpsSistema() {
  const base =
    window?.config?.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL || "";
  const controle = new AbortController();
  const temporizador = setTimeout(() => controle.abort(), TEMPO_LIMITE_MS);

  try {
    // fetch direto, sem `services/api`: o interceptor de lá exige login, e o
    // boot acontece antes dele (inclusive na tela de login e no portal).
    const resposta = await fetch(`${base}/config/erps`, {
      signal: controle.signal,
    });
    if (!resposta.ok) throw new Error(`HTTP ${resposta.status}`);
    const { tipos: doBackend } = await resposta.json();
    definir(doBackend, "backend");
  } catch (error) {
    console.warn(
      "[erpSistema] Não foi possível consultar os ERPs no backend; usando REACT_APP_ERP.",
      error,
    );
    definir([variavelFront()], "variavel");
  } finally {
    clearTimeout(temporizador);
    carregadoNoBoot = true;
  }
  return getErpsSistema();
}

// Antes do boot (ou se ele não rodou), cai na variável do front — relida a
// cada chamada até o boot terminar (ela pode ser definida depois, ex.: testes).
const garantir = () => {
  if (!carregadoNoBoot) definir([variavelFront()], "variavel");
};

/** Tipos de ERP do sistema, na ordem de cadastro. Ex.: ["HUBSOFT", "IXC"]. */
export function getErpsSistema() {
  garantir();
  return [...tipos];
}

/** Primeiro ERP (substituto direto da antiga `const ERP`), ou "" se nenhum. */
export function getErpPrincipal() {
  garantir();
  return tipos[0] || "";
}

/** O sistema usa este tipo de ERP? Ex.: temErp("HUBSOFT"). */
export function temErp(tipo) {
  garantir();
  return tipos.includes(tipo);
}

/** De onde veio o valor: "backend", "variavel" ou "nenhum" (diagnóstico). */
export function getOrigemErpsSistema() {
  garantir();
  return origem;
}
